// extracted by mini-css-extract-plugin
module.exports = {"status":"DriverStatus_status_1jBtI","left":"DriverStatus_left_1jdoW","buttons":"DriverStatus_buttons_3mutt","finish_work":"DriverStatus_finish_work_2v-GO"};